'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('input', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      class: ['toggle', {
        'toggle-disabled': _vm.disabled,
        'toggle-checked': _vm.value
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.value
      },
      on: {
        "click": _vm.onClick
      }
    });
  },
  staticRenderFns: [],
  name: 'toggle',
  props: {
    value: Boolean,
    disabled: Boolean,
    beforeChange: Function
  },
  data: function data() {
    return {};
  },
  methods: {
    onClick: function onClick() {
      if (!(this.beforeChange && !this.beforeChange(!this.value, this.value)) && !this.disabled) {
        this.$emit('input', !this.value);
      }
    }
  }
});

exports.default = index;
